import { Palette } from "lucide-react";
import OptionsWrapper from "../OptionsWrapper/OptionsWrapper";
import {
  TaskDisplayControls,
  type TaskColorDraft,
} from "../TaskColorEditor/TaskColorEditor";

type Colors = { bar: string; soft: string; ink: string };
type Props = {
  title: string;
  listName: string;
  colors: Colors;
  value: TaskColorDraft;
  fallbackBar: string;
  fallbackBg: string | null;
  onChange: (value: TaskColorDraft) => void;
  onBack: () => void;
};

export default function PatternDisplayView({
  title,
  listName,
  colors,
  value,
  fallbackBar,
  fallbackBg,
  onChange,
  onBack,
}: Props) {
  return (
    <OptionsWrapper onBack={onBack} title="Display" accentColor={colors.ink}>
      <TaskDisplayControls
        value={value}
        onChange={onChange}
        previewTitle={title}
        previewLabel={listName}
        fallbackBar={fallbackBar}
        fallbackBg={fallbackBg}
        accent={colors}
      />
    </OptionsWrapper>
  );
}
